var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.component,{tag:"component",staticClass:"pt-8 pb-10 pt-lg-12 pb-lg-16"},[(_vm.title)?_c('TitleWidget',{staticClass:"mb-8"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),(_vm.loading)?_c('LoadingWidget'):[_vm._t("default")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }